import React from 'react'
import styled from 'styled-components'

import { shortDateTime, shortTime } from 'helpers/formatters'

import { color } from 'styles/colors'

const LastUpdatedText = ({ timestamp, className, timeOnly = false }: { timestamp: string | number, className?: string, timeOnly?: boolean }) => {
  return <S.Text className={className}>Last Updated: <span>{timeOnly ? shortTime(timestamp) : shortDateTime(timestamp)}</span></S.Text>
}

export default LastUpdatedText

const S = {
  Text: styled.div`
    margin-bottom: 20px;
    font-size: 12px;
    color: ${color('secondaryText')};
  `
}
